import ModalSkeleton from "../../../components/ModalSkeleton";
import React, { useEffect, useState } from "react";
import classes from "./AddAndRefund.module.css";
import { Input } from "../../../components/Input";
import { Row, Col } from "react-bootstrap";
import { ReceivePaymentIcon } from "../../../constant";
import clsx from "clsx";
import { NoteIcon } from "../../../constant";
import ModalAction from "../../../components/ModalAction";
import { useFormik } from "formik";
import { refundAndCancelSchema } from "../../../schema";
import { toast } from "react-toastify";
import LeftSide from "../../../components/LeftSide";
const initialValues = {
  totalAmount: "",
  refundAmount: "",
  reason: "",
};

const InputIconSide = ({ disabled, onSubmit, right = false }) => (
  <span className={classes.leftSide}>
    <ReceivePaymentIcon className={classes.icon} />
    {right && (
      <span
        className={clsx(classes.unit, {
          [classes.disabled]: disabled,
        })}
      >
        Rs.
      </span>
    )}
  </span>
);
const AddAndRefundModal = ({ show, setShow, data, onSubmit, title="Refund And Cancel", type="" }) => {
  console.log("data AddAndRefundModal", data);
  const [charCount, setCharCount] = useState(0);
  const MAX_CHARS = 10000;

  useEffect(() => {
    console.log("data == >>  << ==", data);
    if (data) {
      console.log("Refund and cancel =", data);
      setFieldValue("totalAmount", data?.bookingCollectedAmount
      );
    }
  }, [data]);
  const formik = useFormik({
    initialValues,
    validationSchema: refundAndCancelSchema,
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      const params = {
        bookingId: data?.bookingId,
        paymentModeId: data?.paymentModeId,
        refundAmount: values?.refundAmount || 0,
        reason: values?.reason,
        ...(type === "refund" && {
          cancelBooking: false,
        }),
      };

      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually

    // Update character count for reason field
    if (field === "reason") {
      setCharCount(value?.length || 0);
    }
  };

  return (
    <>
      <ModalSkeleton
        width="700px"
        show={show}
        setShow={setShow}
        title={title}
      >
        <form onSubmit={handleSubmit}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <Input
                type="number"
                leftIcon={<InputIconSide disabled={true} right="true" />}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                disabled={true}
                labelStyle={{ fontSize: "16px" }}
                label={"Collected Amount"}
                placeholder="Enter Amount"
                value={values?.totalAmount}
                onChange={handleChangeWithTouch("totalAmount")}
              />
            </Col>
            <Col md={6}>
              <Input
                leftIcon={<InputIconSide disabled={true} right="true" />}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                labelStyle={{ fontSize: "16px" }}
                label={"Refund Amount"}
                placeholder="Enter Refund Amount"
                value={values?.refundAmount}
                onChange={(e) => {
                  const refundAmount = Number(e);
                  const totalAmount = Number(values?.totalAmount);

                  if (refundAmount > totalAmount) {
                    toast.warn(
                      "Refund amount cannot be greater than collected amount"
                    );
                    return;
                  }
                  handleChangeWithTouch("refundAmount")(refundAmount);
                }}
                errorText={touched?.refundAmount && errors?.refundAmount}
              />
            </Col>
        {    type !== "refund" && <Col md={12}>
              <Input
                isOptional={true}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="text"
                leftIcon={<NoteIcon />}
                labelStyle={{ fontSize: "16px" }}
                label={"Reason"}
                placeholder="Enter Reason"
                value={values?.reason}
                onChange={(e) => {
                  // Validate character count
                  if (e?.length > MAX_CHARS) {
                    toast.warn(`Reason cannot exceed ${MAX_CHARS} characters`);
                    return;
                  }
                  handleChangeWithTouch("reason")(e);
                }}
                errorText={
                  (touched?.reason && errors?.reason) ||
                  (charCount > MAX_CHARS &&
                    `Reason cannot exceed ${MAX_CHARS} characters`)
                }
              />
              <div className={classes.charCounter}>
                {charCount}/{MAX_CHARS} characters
              </div>
            </Col>}
          </Row>

          <ModalAction type="submit" onCancel={() => setShow(false)} />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default AddAndRefundModal;
